import { TokenRecord } from 'src/bbe_interfaces_v2';

// src/api/tokenStorage.ts
const OLD_ACCESS_TOKEN_KEY = 'userToken';
const ACCESS_TOKEN_KEY = 'accessToken';
const ACCESS_EXPIRY_KEY = 'accessExpiry';
const REFRESH_TOKEN_KEY = 'refreshToken';
const REFRESH_EXPIRY_KEY = 'refreshExpiry';
const ISSUED_KEY = 'issuedAt';

export const tokenStorage = {
  get(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },
  getAccessExpiry(): string | null {
    return localStorage.getItem(ACCESS_EXPIRY_KEY);
  },
  set(token: TokenRecord) {
    localStorage.setItem(OLD_ACCESS_TOKEN_KEY, token.access);
    localStorage.setItem(ACCESS_TOKEN_KEY, token.access);
    localStorage.setItem(ACCESS_EXPIRY_KEY, token.access_expiry.toString());
    localStorage.setItem(REFRESH_TOKEN_KEY, token.refresh);
    localStorage.setItem(REFRESH_EXPIRY_KEY, token.refresh_expiry.toString());
    localStorage.setItem(ISSUED_KEY, token.iat.toString());
  },
  clear() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(ACCESS_EXPIRY_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(REFRESH_EXPIRY_KEY);
    localStorage.removeItem(ISSUED_KEY);
  },
};
